<tl-icon-wrapper #animationRoot>
  <wvr-icon-component
    [color]="color"
    [name]="name"
    [set]="set"
    [size]="size">
  </wvr-icon-component>
</tl-icon-wrapper>
